(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lalya-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-lalya-hero-cycle]').forEach((cycle) => {
      const slides = Array.from(cycle.querySelectorAll('[data-lalya-hero-slide]'));
      if (slides.length < 2) return;

      let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (activeIndex < 0) activeIndex = 0;

      window.setInterval(() => {
        slides[activeIndex].classList.remove('is-active');
        activeIndex = (activeIndex + 1) % slides.length;
        slides[activeIndex].classList.add('is-active');
      }, 2000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lalya-first-drop-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const initDropCycles = (root = document) => {
      root.querySelectorAll('[data-lalya-drop-cycle]').forEach((cycle) => {
        if (cycle.dataset.lalyaCycleReady === 'true') return;

        const slides = Array.from(cycle.querySelectorAll('[data-lalya-drop-slide]'));
        if (slides.length < 2) return;

        cycle.dataset.lalyaCycleReady = 'true';

        let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (activeIndex < 0) {
          activeIndex = 0;
          slides[activeIndex].classList.add('is-active');
        }

        if (reducedMotion) return;

        window.setInterval(() => {
          if (document.hidden) return;
          slides[activeIndex].classList.remove('is-active');
          activeIndex = (activeIndex + 1) % slides.length;
          slides[activeIndex].classList.add('is-active');
        }, 2000);
      });
    };

    initDropCycles();
    document.addEventListener('shopify:section:load', (event) => initDropCycles(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lalya-product-marquee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-lalya-marquee-cycle]').forEach((cycle, cycleIndex) => {
      const slides = Array.from(cycle.querySelectorAll('[data-lalya-marquee-slide]'));
      if (slides.length < 2) return;

      let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (activeIndex < 0) activeIndex = 0;

      const delay = 2000 + (cycleIndex % 4) * 180;

      window.setInterval(() => {
        slides[activeIndex].classList.remove('is-active');
        activeIndex = (activeIndex + 1) % slides.length;
        slides[activeIndex].classList.add('is-active');
      }, delay);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lalya-visual-shop-path"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-lalya-panel-cycle]').forEach((cycle) => {
      const slides = Array.from(cycle.querySelectorAll('[data-lalya-panel-slide]'));
      if (slides.length < 2) return;

      let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (activeIndex < 0) activeIndex = 0;

      window.setInterval(() => {
        slides[activeIndex].classList.remove('is-active');
        activeIndex = (activeIndex + 1) % slides.length;
        slides[activeIndex].classList.add('is-active');
      }, 3000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monarch-boniko-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const initCard = (card) => {
      if (card.dataset.mBonikoReady === 'true') return;

      const images = Array.from(card.querySelectorAll('.m-boniko-card__cycle-image'));
      const links = card.querySelectorAll('[data-m-boniko-product-link]');
      const price = card.querySelector('[data-m-boniko-price]');
      const comparePrice = card.querySelector('[data-m-boniko-compare-price]');
      const badge = card.querySelector('.m-boniko-card__badge');
      const swatches = Array.from(card.querySelectorAll('[data-m-boniko-swatch]'));
      let timer;

      images.forEach((image, imageIndex) => {
        image.dataset.defaultSrc = image.getAttribute('src') || '';
        image.dataset.defaultSrcset = image.getAttribute('srcset') || '';
        if (image.classList.contains('is-active')) {
          card.dataset.mBonikoCycleIndex = String(imageIndex);
        }
      });

      if (!card.dataset.mBonikoCycleIndex) {
        card.dataset.mBonikoCycleIndex = '0';
      }

      const setImageAttrs = (image, src, srcset) => {
        if (!image || !src) return;
        if (image.getAttribute('src') === src && (image.getAttribute('srcset') || '') === (srcset || '')) return;

        image.classList.add('is-changing');

        window.requestAnimationFrame(() => {
          image.setAttribute('src', src);

          if (srcset) {
            image.setAttribute('srcset', srcset);
          } else {
            image.removeAttribute('srcset');
          }

          window.setTimeout(() => image.classList.remove('is-changing'), 140);
        });
      };

      const showCycleImage = (index) => {
        if (!images.length) return;

        const safeIndex = ((index % images.length) + images.length) % images.length;
        const image = images[safeIndex];

        setImageAttrs(image, image.dataset.defaultSrc, image.dataset.defaultSrcset);

        images.forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex === safeIndex);
        });

        card.dataset.mBonikoCycleIndex = String(safeIndex);
      };

      const showExternalImage = (src, srcset) => {
        if (!images.length || !src) return;

        const image = images[0];

        setImageAttrs(image, src, srcset);

        images.forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex === 0);
        });
      };

      const activeSwatch = () => card.querySelector('[data-m-boniko-swatch].is-active');

      const restoreImage = () => {
        const selected = activeSwatch();

        if (card.dataset.mBonikoVariantLocked === 'true' && selected?.dataset.imageSrc) {
          showExternalImage(selected.dataset.imageSrc, selected.dataset.imageSrcset);
          return;
        }

        showCycleImage(Number(card.dataset.mBonikoCycleIndex) || 0);
      };

      const previewSwatch = (swatch) => {
        if (swatch.dataset.imageSrc) {
          showExternalImage(swatch.dataset.imageSrc, swatch.dataset.imageSrcset);
        }
      };

      const selectSwatch = (swatch) => {
        swatches.forEach((item) => item.classList.toggle('is-active', item === swatch));
        previewSwatch(swatch);
        card.dataset.mBonikoVariantLocked = swatch.dataset.imageSrc ? 'true' : 'false';

        if (swatch.dataset.productUrl) {
          links.forEach((link) => {
            link.setAttribute('href', swatch.dataset.productUrl);
          });
        }

        if (price && swatch.dataset.price) {
          price.textContent = swatch.dataset.price;
        }

        if (comparePrice) {
          if (swatch.dataset.comparePrice) {
            comparePrice.textContent = swatch.dataset.comparePrice;
            comparePrice.hidden = false;
          } else {
            comparePrice.textContent = '';
            comparePrice.hidden = true;
          }
        }

        if (badge) {
          badge.hidden = swatch.dataset.sale !== 'true';
        }
      };

      swatches.forEach((swatch) => {
        swatch.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') {
            previewSwatch(swatch);
          }
        });

        swatch.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'mouse') {
            restoreImage();
          }
        });

        swatch.addEventListener('focus', () => previewSwatch(swatch));
        swatch.addEventListener('blur', restoreImage);
        swatch.addEventListener('click', () => selectSwatch(swatch));
      });

      card.dataset.mBonikoReady = 'true';

      if (!reducedMotion && images.length > 1) {
        const siblingCards = Array.from(card.parentElement?.children || []);
        const offset = Math.max(siblingCards.indexOf(card), 0) * 360;

        window.setTimeout(() => {
          if (!card.isConnected) return;

          timer = window.setInterval(() => {
            if (!card.isConnected) {
              window.clearInterval(timer);
              return;
            }

            if (card.dataset.mBonikoVariantLocked === 'true') return;
            if (card.matches(':hover') || card.matches(':focus-within')) return;

            showCycleImage((Number(card.dataset.mBonikoCycleIndex) || 0) + 1);
          }, 2800);
        }, offset % 1800);
      }
    };

    const init = (root = document) => {
      root.querySelectorAll('.m-boniko-card').forEach(initCard);
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monarch-customer-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('monarch-customer-stories')) {
    class MonarchCustomerStories extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-story-rail]');
        this.controls = this.querySelector('[data-story-controls]');
        this.buttons = Array.from(this.querySelectorAll('[data-story-direction]'));

        if (!this.rail || this.buttons.length === 0) return;

        this.handleClick = this.handleClick.bind(this);
        this.updateControls = this.updateControls.bind(this);

        this.buttons.forEach((button) => button.addEventListener('click', this.handleClick));
        this.resizeObserver = new ResizeObserver(this.updateControls);
        this.resizeObserver.observe(this.rail);
        this.updateControls();
      }

      disconnectedCallback() {
        this.buttons?.forEach((button) => button.removeEventListener('click', this.handleClick));
        this.resizeObserver?.disconnect();
      }

      handleClick(event) {
        const card = this.rail.querySelector('[data-story-card]');
        if (!card) return;

        const gap = Number.parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        const isRtl = getComputedStyle(this.rail).direction === 'rtl';
        const requestedDirection = event.currentTarget.dataset.storyDirection === 'next' ? 1 : -1;
        const direction = isRtl ? requestedDirection * -1 : requestedDirection;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

        this.rail.scrollBy({ left: step * direction, behavior });
      }

      updateControls() {
        if (!this.controls) return;
        this.controls.hidden = this.rail.scrollWidth <= this.rail.clientWidth + 1;
      }
    }

    customElements.define('monarch-customer-stories', MonarchCustomerStories);
  }

  } catch(e) { console.error(e); }
})();
})();
